<template>
  <div class="div-wrapper-subsection">
    <div class="frame-10">
      <div class="image-2-wrapper">
        <img
          class="image-2"
          alt="Image"
          :src="`${publicBase}assets/fonctionnalites/centralise.webp`"
        />
      </div>
      <div class="frame-11">
        <div class="gestion-des">
          Gestion des commandes
          <br />
          centralisée
        </div>
        <p class="text-wrapper-3">
          Dites adieu au chaos des commandes. Florisuite simplifie la prise,
          le suivi et la livraison de toutes vos commandes, en ligne ou en
          magasin.
        </p>
        <div class="frame-12">
          <div class="frame-13">
            <img
              class="circle-check-big-2"
              alt="Circle check big"
              src="https://c.animaapp.com/nNxA75tB/img/circle-check-big-7.svg"
            />
            <p class="text-wrapper-4">Suivi de commande en temps réel</p>
          </div>
          <div class="frame-13">
            <img
              class="circle-check-big-2"
              alt="Circle check big"
              src="https://c.animaapp.com/nNxA75tB/img/circle-check-big-7.svg"
            />
            <div class="text-wrapper-4">
              Planification de livraison optimisée
            </div>
          </div>
          <div class="frame-13">
            <img
              class="circle-check-big-2"
              alt="Circle check big"
              src="https://c.animaapp.com/nNxA75tB/img/circle-check-big-7.svg"
            />
            <div class="text-wrapper-4">
              Notifications clients automatisées
            </div>
          </div>
          <div class="frame-13">
            <img
              class="circle-check-big-2"
              alt="Circle check big"
              src="https://c.animaapp.com/nNxA75tB/img/circle-check-big-7.svg"
            />
            <p class="text-wrapper-4">
              Historique complet des commandes pour un meilleur service client
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "DivWrapperSubsection",
  data() {
    return {
      publicBase: process.env.BASE_URL || "/",
    };
  },
});
</script>

<style>
.div-wrapper-subsection {
  align-items: center;
  align-self: stretch;
  background-color: #fafafa;
  border: 0px none;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  padding: 100px 30px;
  position: relative;
  width: 100%;
}

.div-wrapper-subsection .frame-10 {
  align-items: center;
  display: grid;
  gap: 64px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  max-width: 1200px;
  position: relative;
  width: 100%;
}

.div-wrapper-subsection .image-2 {
  display: block;
  height: 100%;
  object-fit: cover;
  object-position: center;
  width: 100%;
}

.div-wrapper-subsection .image-2-wrapper {
  aspect-ratio: 1.29;
  border-radius: 10px;
  height: 100%;
  min-height: 271.88px;
  min-width: 0;
  overflow: hidden;
  position: relative;
  width: 100%;
}

.div-wrapper-subsection .frame-11 {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 21px;
  min-width: 0;
  position: relative;
  width: 100%;
}

.div-wrapper-subsection .gestion-des {
  align-self: stretch;
  color: #1a1a1a;
  font-family: "Montserrat", Helvetica;
  font-size: 36px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 45px;
  margin-top: -1.00px;
  position: relative;
}

.div-wrapper-subsection .text-wrapper-3 {
  align-self: stretch;
  color: #5f5f5f;
  font-family: "Open Sans", Helvetica;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 28px;
  position: relative;
}

.div-wrapper-subsection .frame-12 {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 12px;
  position: relative;
  width: 100%;
}

.div-wrapper-subsection .frame-13 {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  gap: 12px;
  position: relative;
  width: 100%;
}

.div-wrapper-subsection .circle-check-big-2 {
  flex-shrink: 0;
  height: 20px;
  position: relative;
  width: 20px;
}

.div-wrapper-subsection .text-wrapper-4 {
  color: #1a1a1a;
  flex: 1;
  font-family: "Open Sans", Helvetica;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 24px;
  margin-top: -1.00px;
  position: relative;
}

@media (max-width: 1024px) {
  .div-wrapper-subsection {
    padding: 80px 24px;
  }

  .div-wrapper-subsection .frame-10 {
    gap: 40px 28px;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }

  .div-wrapper-subsection .gestion-des {
    font-size: 32px;
    line-height: 40px;
  }
}

@media (max-width: 768px) {
  .div-wrapper-subsection {
    padding: 64px 20px;
  }

  .div-wrapper-subsection .frame-10 {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    gap: 28px;
  }

  .div-wrapper-subsection .frame-11 {
    order: 1;
  }

  .div-wrapper-subsection .image-2-wrapper {
    min-height: 0;
    order: 2;
  }

  .div-wrapper-subsection .gestion-des {
    font-size: 28px;
    line-height: 34px;
  }

  .div-wrapper-subsection .gestion-des br {
    display: none;
  }

  .div-wrapper-subsection .text-wrapper-3 {
    font-size: 16px;
    line-height: 25px;
  }

  .div-wrapper-subsection .text-wrapper-4 {
    font-size: 15px;
    line-height: 23px;
  }
}

@media (max-width: 480px) {
  .div-wrapper-subsection {
    padding: 52px 16px;
  }

  .div-wrapper-subsection .gestion-des {
    font-size: 24px;
    line-height: 30px;
  }

  .div-wrapper-subsection .frame-12 {
    gap: 10px;
  }
}
</style>
